(function () {
  'use strict';

  // ── Format money using theme's currency format ───────────
  function formatMoney(cents) {
    var fmt = (window.theme && window.theme.settings && window.theme.settings.moneyFormat) || '${{amount}}';
    var dollars = cents / 100;
    var amount = dollars % 1 === 0 ? dollars.toFixed(0) : dollars.toFixed(2);
    return fmt
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100));
  }

  // ── Inject reason text from JSON metafield ───────────────
  function injectReasons() {
    var grid = document.querySelector('[data-upsell-reasons]');
    if (!grid) return;
    var raw = grid.getAttribute('data-upsell-reasons');
    if (!raw) return;
    var reasons;
    try { reasons = JSON.parse(raw); } catch (e) { return; }
    if (!Array.isArray(reasons)) return;
    document.querySelectorAll('.upsell-fbt__reason[data-reason-index]').forEach(function (el) {
      var idx = parseInt(el.getAttribute('data-reason-index'), 10);
      if (reasons[idx]) el.textContent = reasons[idx];
    });
  }

  // ── Apply bundle discount UI to product cards ────────────
  function initDiscount() {
    var grid = document.querySelector('[data-discount-enabled]');
    if (!grid || grid.getAttribute('data-discount-enabled') !== 'true') return;

    var discountValue = parseFloat(grid.getAttribute('data-discount-value') || 0);
    if (!discountValue) return;

    var discountLabel  = grid.getAttribute('data-discount-label') || 'Bundle deal';
    var minCartDollars = parseFloat(grid.getAttribute('data-discount-min-cart') || 0);
    var minCartCents   = minCartDollars * 100;
    var productPrice   = parseInt(grid.getAttribute('data-product-price') || 0, 10);
    var showSavings    = grid.getAttribute('data-show-savings') !== 'false';
    var showOriginal   = grid.getAttribute('data-show-original') !== 'false';

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Qualify if cart + current product price meets minimum
        if (minCartCents > 0 && (cart.total_price + productPrice) < minCartCents) return;

        document.querySelectorAll('.upsell-fbt__item[data-price]').forEach(function (item) {
          var priceCents      = parseInt(item.getAttribute('data-price'), 10);
          if (!priceCents) return;
          var discountedCents = Math.round(priceCents * (1 - discountValue / 100));
          var savingsCents    = priceCents - discountedCents;

          // Rebuild price display
          var priceEl = item.querySelector('.upsell-fbt__price');
          if (!priceEl) return;
          var html = '';
          if (showOriginal) {
            html += '<span class="product__price product__price--compare">' + formatMoney(priceCents) + '</span> ';
          }
          html += '<span class="on-sale">' + formatMoney(discountedCents) + '</span>';
          if (showSavings) {
            html += '<br><span class="upsell-fbt__save-badge tag">Save ' + formatMoney(savingsCents) + '</span>';
          }
          priceEl.innerHTML = html;

          // Add badge label below price (only if not already added)
          if (!item.querySelector('.upsell-fbt__disc-label')) {
            var badge = document.createElement('span');
            badge.className = 'upsell-fbt__disc-label tag';
            badge.style.marginBottom = '8px';
            badge.style.display = 'inline-block';
            badge.textContent = discountLabel;
            priceEl.insertAdjacentElement('afterend', badge);
          }
        });
      })
      .catch(function () {}); // Fail silently — show regular prices
  }

  // ── Update header cart count ─────────────────────────────
  function updateCartCount(itemCount) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = itemCount;
    });
    document.querySelectorAll('.cart-link__bubble-num').forEach(function (el) {
      el.textContent = itemCount;
    });
    document.querySelectorAll('.cart-link__bubble').forEach(function (b) {
      b.classList.toggle('cart-link__bubble--visible', itemCount > 0);
    });
  }

  // ── Open the Impulse cart drawer ─────────────────────────
  function openCartDrawer() {
    var trigger = document.querySelector('.js-drawer-open-cart');
    if (trigger) { trigger.click(); return; }
    var drawer = document.getElementById('CartDrawer');
    if (drawer) {
      drawer.classList.add('drawer--is-open');
      document.documentElement.classList.add('js-drawer-open', 'js-drawer-open-cart');
    }
  }

  // ── Add to cart via Shopify AJAX API ─────────────────────
  function addToCart(variantId, btn) {
    var origText = btn.textContent;
    btn.textContent = '\u2026';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart add failed');
        return r.json();
      })
      .then(function () {
        btn.textContent = '\u2713 Added';
        btn.setAttribute('data-added', 'true');
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            document.dispatchEvent(new CustomEvent('upsell:cart-updated', { detail: cart }));
            openCartDrawer();
          })
          .catch(function () { openCartDrawer(); });
      })
      .catch(function () {
        btn.textContent = origText;
        btn.disabled = false;
      });
  }

  // ── Bind ATC buttons on product page ────────────────────
  function bindAtcButtons() {
    document.querySelectorAll('.upsell-fbt__atc:not([data-upsell-bound])').forEach(function (btn) {
      btn.setAttribute('data-upsell-bound', '1');
      btn.addEventListener('click', function () {
        var variantId = parseInt(this.getAttribute('data-variant-id'), 10);
        if (variantId) addToCart(variantId, this);
      });
    });
  }

  // ── Init ─────────────────────────────────────────────────
  function init() {
    injectReasons();
    initDiscount();
    bindAtcButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
